import axios from '@/lib/AxApi';

export default {
    async selectDocuments(params)
    {
        try
        {
            const response = await axios.get('/ChildDocuments/selectDocuments',
                {
                    params,
                });
            return response.data;
        }
        catch (e)
        {
            throw ({ error: true, notice: axios.errorHandler(e) });
        }
    },
    async insertDocument(params)
    {
        try
        {
            const response = await axios.post('/ChildDocuments/insertDocument', params);
            return response.data;
        }
        catch (e)
        {
            throw ({ error: true, notice: axios.errorHandler(e) });
        }
    },
    async deleteRow(params)
    {
        try
        {
            const response = await axios.post('/ChildDocuments/deleteRow', params);
            return response.data;
        }
        catch (e)
        {
            throw ({ error: true, notice: axios.errorHandler(e) });
        }
    },
};
